import type { Device } from '@studio/models/device';
import { locateProxy } from '#~/agent/index.js';
import { StudioError } from '#~/error/index.js';

/** @internal */
export const audioEgress = async (
  deviceId: Device['id'],
  defaultName: string,
  onOrOff: boolean
): Promise<void> => {
  const proxy = locateProxy(deviceId);

  if (!proxy) {
    throw new Error('PW-79B');
  }

  // If the user doesn't set a sink name, we'll use the default source name.
  const mutation = {
    control: {
      studio: {
        device: {
          [deviceId]: {
            audioEgress: {
              ndi: {
                enable: onOrOff,
                sinkName: defaultName
              }
            }
          }
        }
      }
    }
  };

  try {
    await proxy.mutate(mutation, {});
  } catch (cause) {
    console.error(cause);
    throw new StudioError('Unable to egress audio.', { cause });
  }
};
